/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-12 16:05:35
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 17:27:23
 */

import classNames from "classnames";
import React, { FC, memo, useCallback } from "react";
import { connect } from "react-redux";
import {
  enterStatusSelector,
  gamblingCountSelector,
  refundPriceSelector,
} from "../../../store/common/selector";
import { keep2Decimal } from "../../../utils/number";
import "./index.less";

const PREFIX = "GamblingPriceModule";

type IProps = {} & ReturnType<typeof mapStateToProps>;

// 报名后，才能进入【进行中页面】，才会显示该模块
const GamblingPriceModule: FC<IProps> = memo(
  ({ gamblingCount, enterStatus, refundPrice }) => {
    const renderRewardText = useCallback(() => {
      if (gamblingCount && refundPrice !== undefined) {
        if (!gamblingCount.complete_count) {
          // 还没有人完成
          return (
            <p className={classNames(`${PREFIX}-bodyText`, "mt4")}>
              还没有人完成挑战，快去完成挑战吧！
            </p>
          );
        } else {
          if (enterStatus == 2) {
            // 用户已经完成挑战
            return (
              <p className={`${PREFIX}-bodyText`}>
                预计你将分得
                <span className={`${PREFIX}-bodyTextNum`}>
                  ¥{keep2Decimal(refundPrice / 100)}
                </span>
              </p>
            );
          } else {
            // 用户还未完成挑战
            return (
              <p className={`${PREFIX}-bodyText`}>
                预计单人奖金
                <span className={`${PREFIX}-bodyTextNum`}>
                  ¥{keep2Decimal(refundPrice / 100)}
                </span>
              </p>
            );
          }
        }
      } else {
        return (
          <p className={`${PREFIX}-bodyText`}>
            预计单人奖金<span className={`${PREFIX}-bodyTextNum`}>¥--</span>
          </p>
        );
      }
    }, [gamblingCount, enterStatus, refundPrice]);

    return (
      <div className={PREFIX}>
        <div className={`${PREFIX}-title`}>·活动奖池·</div>
        <div className={`${PREFIX}-body`}>
          <p className={classNames(`${PREFIX}-bodyText`, "is-firstLine")}>
            总奖金池
            <span className={`${PREFIX}-bodyTextNum`}>
              ¥{gamblingCount ? (gamblingCount.amount || 0) / 100 : "--"}
            </span>
          </p>
          {renderRewardText()}
          <p className={classNames(`${PREFIX}-bodyText`, 'is-comment')}>
            活动结束后，完成挑战的咚友将会获得奖金
          </p>
        </div>
      </div>
    );
  }
);

const mapStateToProps = (state: any) => {
  return {
    gamblingCount: gamblingCountSelector(state),
    refundPrice: refundPriceSelector(state),
    enterStatus: enterStatusSelector(state),
  };
};

export default connect(mapStateToProps)(GamblingPriceModule);
